import GetStyled from '../../components/style-selection/get-styled.vue';

export default {
    path: '/get-styled',
    component: GetStyled,
    meta: {
        requiresAuth: true
    }
};